
import {trigger, filter, lazy} from './lang.js';
import Tone from 'tone';

const TIME_32n = new Tone.Time('32n');


export const swing = (percentage) => {
    return (...args) => {
        let [stepData, stepNumber, time] = args;
        if (!stepData) {
            return filter(true);
        }
        let _percentage = lazy(percentage, ...args);

        if (Math.floor(stepNumber / 2) % 2 !== 0) {
            return trigger({
                stepData,
                time: time + TIME_32n * (_percentage - 50) / 50,
                stepNumber
            });
        } else {
            return filter(true);
        }
    };
};

export const offset = (percentage) => {
    return (...args) => {
        let [stepData, stepNumber, time] = args;
        if (!stepData) {
            return filter(true);
        }
        let _percentage = lazy(percentage, ...args);

        return trigger({
            stepData,
            time: time + TIME_32n * (_percentage ) / 100,
            stepNumber
        });
    };
};

